import React from 'react';
import { useLanguage } from '../context/LanguageContext.jsx';

export function ErrorMessage({ message, onRetry }) {
  const { t } = useLanguage();

  return (
    <div className="alert-box alert-danger" role="alert">
      <div>⚠️</div>
      <div style={{ flex: 1 }}>
        <p style={{ color: 'inherit', fontWeight: 500 }}>
          {message || t('pageNotFoundDesc')}
        </p>
        {onRetry && (
          <button
            type="button"
            className="btn btn-outline"
            onClick={onRetry}
            style={{ marginTop: '0.5rem', fontSize: '0.8125rem', padding: '0.25rem 0.625rem' }}
          >
            {t('retry')}
          </button>
        )}
      </div>
    </div>
  );
}
